import React from 'react';
import { motion } from 'framer-motion';
import fastestlogo from "../assets/images/fastest-logo-bold.png";

export default function WeAreBuildingBanking() {
    return (
        <div className='inner_bg about'>
            <div className="max-w-100vw h-[50vh] flex gap-2 justify-center items-center px-[10%] py-[3%]">

                {/* Logo with Animation */}
                <motion.div
                    className='border-r-2 border-[#2AD5FF]'
                    initial={{ opacity: 0, x: -100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ type: 'spring', stiffness: 80, damping: 25 }}
                >
                    <img src={fastestlogo} alt="fastestlogo" className='w-[65%]' />
                </motion.div>

                {/* Heading with Animation */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                >
                    <h2 className='px-4 text-[1.1rem] md:text-[2rem] leading-[1.1] font-[800] bg-gradient-to-r from-[#2AD5FF] to-[#D71E7E] bg-clip-text text-transparent'>
                        We're Building Banking for <br /> the Internet Economy
                    </h2>
                </motion.div>
            </div>
        </div>
    );
}
